module.exports = __webpack_public_path__ + "static/media/album-d3k.7497d88c.png";